export default __webpack_public_path__ + "static/media/Devil.b8a22f71.jpg";